<template>
  <CrudList
    title="Spots eliminados"
    storeName="Deleted_spots"
    slot-scope="{ item }"
    sortable
    canSearch
    :canAdd="false"
    :canEdit="false"
    :canDelete="false"
    next-link="/admin/cars"
    :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/deleted_spots'
      },
      {
        text: 'Spots eliminados',
        disabled: false,
        href: '#'
      }
    ]"
  >
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
